export const getApplicationStatusText = (status: string) => {
  switch (status) {
    case "pending":
      return "Pendente";
    case "in_process":
      return "Em Progresso";
    case "finished":
      return "Finalizada";
    case "cancelled":
      return "Cancelada";
    case "error":
      return "Erro";
    case "completed":
      return "Concluída";
    default:
      return status;
  }
};

export const getStatusBadgeClass = (status: string) => {
  switch (status) {
    case "pending":
      return "bg-warning";
    case "in_process":
      return "bg-info";
    case "finished":
      return "bg-success";
    case "cancelled":
      return "bg-danger";
    case "error":
      return "bg-danger";
    case "completed":
      return "bg-success";
    default:
      return "bg-secondary";
  }
};
